import * as React from "react";

const SvgComponent = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none" {...props}>
		<path
			d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16z"
			fill="#25d366"
		/>
		<path
			d="M16.529 24.902h-.004a9.514 9.514 0 0 1-4.547-1.158l-5.044 1.323 1.35-4.93a9.491 9.491 0 0 1-1.27-4.756 9.53 9.53 0 0 1 9.514-9.514 9.45 9.45 0 0 1 6.73 2.79 9.458 9.458 0 0 1 2.784 6.731 9.53 9.53 0 0 1-9.514 9.514zm-4.317-2.88.289.171a7.895 7.895 0 0 0 4.025 1.102h.003a7.92 7.92 0 0 0 7.908-7.908 7.86 7.86 0 0 0-2.314-5.594 7.855 7.855 0 0 0-5.591-2.319 7.92 7.92 0 0 0-7.911 7.907A7.89 7.89 0 0 0 9.83 19.59l.188.299-.799 2.918 2.993-.785zm9.11-4.371c-.059-.099-.218-.159-.456-.278s-1.406-.694-1.624-.773-.376-.119-.535.119-.614.774-.753.932-.277.178-.515.059-1.004-.37-1.912-1.18c-.707-.63-1.184-1.409-1.322-1.647s-.015-.367.104-.485c.107-.106.238-.278.357-.416s.159-.238.238-.396.04-.298-.02-.417-.535-1.289-.733-1.765c-.193-.463-.389-.401-.535-.408l-.456-.008s-.416.059-.634.297-.832.813-.832 1.983.852 2.3.971 2.459 1.676 2.56 4.061 3.59c.567.245 1.01.391 1.355.501.57.181 1.088.155 1.497.094.457-.068 1.407-.575 1.605-1.13s.198-1.031.139-1.13z"
			fill="#fdfdfd"
		/>
	</svg>
);

export default SvgComponent;
